export class RegisterPageModel
{
    public FirstName: string | null = null;

    public LastName: string | null = null;

    public Email: string | null = null;

    public Password: string | null = null;

    public ConfirmPassword: string | null = null;

    public Name: string | null = null;

    public Domain: string | null = null;

    public AcceptTerms: boolean = false;
}
